import React from "react"

function Error() {
    return(
        <div class="container text-center">
            <p className="display-1">404</p>
            <p className="display-2">Oops! Page not found!!</p>
        </div>
    )
}

export default Error